import React, { useState, useContext } from 'react';
import {
	ApChip,
	ApIcon,
	colors,
	ApButtonSecondary,
} from '@alixpartners/ui-components';
import { SettingsContext } from 'contexts/SettingsContext';
import { FilterRow } from '../FilterRow';
import {
	StyledMenu,
	Wrapper,
	NoData,
	ListWrapper,
	TitleWraper,
	Label,
	Footer,
	CounterWrapper,
} from './CustomFilters.styles';
import AgDropDown from '../AgDropDown/AgDropDown';
import { CategoryManagementContext } from '../../../contexts/CategoryManagementContext';

const CustomFilters = props => {
	const { customFilters, customFiltersValues } = props;
	const { customFilters: options } = useContext(SettingsContext);
	const { handleCustomFilterChange } = useContext(CategoryManagementContext);

	const [isOpen, setIsOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedFilter, setSelectedFilter] = useState(null);

	const closeFilter = () => {
		setSelectedFilter(null);
	};

	const selectFilter = filter => {
		setSelectedFilter(filter);
		setSearchQuery('');
	};

	const clearAll = () => {
		handleCustomFilterChange({
			customFilters: [],
			customFiltersValues: [],
		});
	};

	const updateFilters = newFilters => {
		handleCustomFilterChange({
			customFilters: newFilters.map(({ name }) => name),
			customFiltersValues: newFilters.map(({ value }) => value),
		});
	};

	const onFilterChange = selectedItems => {
		const filterName = selectedFilter?.columnName;
		const existingFiltersWithoutCurrent = customFilters
			.map((filterName, index) => ({
				name: filterName,
				value: customFiltersValues[index],
			}))
			.filter(({ name }) => name !== filterName);

		const newFilters = [
			...existingFiltersWithoutCurrent,
			...selectedItems.map(filterValue => ({
				name: filterName,
				value: filterValue,
			})),
		];

		updateFilters(newFilters);
	};

	const getCustomFiltersList = () => {
		const activeFilters = options
			? options.filter(({ isActive }) => isActive)
			: [];
		if (!searchQuery) {
			return activeFilters;
		}
		return activeFilters.filter(item =>
			item.label.toLowerCase().includes(searchQuery.toLowerCase())
		);
	};

	const getSelectedItems = name => {
		const filterName = name || selectedFilter?.columnName;
		const isActiveFilter = customFilters.includes(filterName);
		const currentValues = isActiveFilter
			? customFilters
					.map((filterName, index) => ({
						name: filterName,
						value: customFiltersValues[index] || '',
					}))
					.filter(({ name }) => name === filterName)
					.map(({ value }) => value)
			: [];
		return currentValues;
	};

	const onMenuClose = () => {
		setSearchQuery('');
		closeFilter();
	};

	const getOtherFiltersSelectedCount = () => {
		return customFilters.length;
	};

	const handleChange = value => {
		onFilterChange(value);
	};

	const overallSelectedCount = getOtherFiltersSelectedCount();
	const filtersList = getCustomFiltersList();

	return (
		<>
			<StyledMenu
				button={
					<div style={{ width: 'fit-content', position: 'relative' }}>
						{!!overallSelectedCount && (
							<CounterWrapper>{overallSelectedCount}</CounterWrapper>
						)}
						<ApChip
							icon="filter_outlined"
							small
							selected={isOpen || !!overallSelectedCount}
						>
							Other Filters
						</ApChip>
					</div>
				}
				placement="bottom-end"
				toggleMenu={setIsOpen}
				onClose={onMenuClose}
				isOpen={isOpen}
				isFullHeight={false}
			>
				<Wrapper>
					{!selectedFilter ? (
						<>
							{filtersList.length === 0 ? (
								<NoData>No results found</NoData>
							) : (
								<ListWrapper>
									{filtersList.map((item, index) => (
										<div key={index} onClick={() => selectFilter(item)}>
											<FilterRow
												searchQuery={searchQuery}
												label={item.label}
												count={getSelectedItems(item.columnName).length}
											/>
										</div>
									))}
								</ListWrapper>
							)}
							<Footer>
								<ApButtonSecondary onClick={clearAll} small>
									Clear Other Filters
								</ApButtonSecondary>
							</Footer>
						</>
					) : (
						<>
							<TitleWraper onClick={closeFilter}>
								<ApIcon
									iconName="baseline_arrow_back"
									iconColor={colors.grey7}
								/>
								<Label>{selectedFilter.label}</Label>
							</TitleWraper>
							<AgDropDown
								selectedFilter={selectedFilter.columnName}
								handleChange={handleChange}
								selectedItems={getSelectedItems()}
							/>
						</>
					)}
				</Wrapper>
			</StyledMenu>
		</>
	);
};

export default CustomFilters;
